export const FILTER_DROPDOWN_MIN_WIDTH = '240px';

/**
 * Width reserved for the Price and Rooms trigger labels, in `ch`.
 *
 * Proxima Nova has no tabular figures — "1" measures 5.4px against "0" at
 * 9.8px, and both `font-variant-numeric: tabular-nums` and
 * `font-feature-settings: "tnum" 1` are no-ops against it. Without a
 * reservation each label resizes as its digits change, which shoves every
 * sibling control in the search bar sideways: a single $100 price tick moved
 * the pill up to 8px, and the Rooms label spans 37.4px ("1+ / 1+") to 79.5px
 * ("2 beds / Any") at `sm`.
 *
 * `ch` is the '0' advance, which is wider than most letters in this bold
 * proportional face — do not equate ch count with character count. Exhaustive
 * canvas-measureText sweeps of every label each trigger can produce give:
 *
 * | trigger | widest label      | sm (14px) | lg (16px) |
 * | ------- | ----------------- | --------- | --------- |
 * | Price   | `$5.5k - $5.6k`   | 84.8px    | 96.9px    |
 * | Rooms   | `2 beds / Any`    | 79.5px    | 90.8px    |
 * | 10ch    |                   | 86.9px    | 99.2px    |
 *
 * Note the Price winner is not the `$10k` boundary — that rounds to the
 * *shorter* "$10k" — but a tied cluster of `$D.Dk - $D.Dk` combos; the Rooms
 * winner is not the longest *string* either. Shared by both triggers so the
 * two pills also keep a consistent width beside each other.
 *
 * `minWidth` rather than `width`, so a longer render (a locale whose labels
 * exceed the English sweep — `es` "Cualquiera"/"habitaciones" do) grows the box
 * instead of clipping. Those locales can still jitter; sizing them needs its
 * own per-locale measurement.
 *
 * Applied via `style`, not the `css` prop: it is a layout guarantee, and Panda
 * class names are hashed in CI, so `style` is the only form a test can read.
 */
export const FILTER_TRIGGER_LABEL_MIN_WIDTH = '10ch';
